$( document ).on('turbolinks:load', function() {
  if ($.trim($('#page-content').html())=='') {
    $('#page-content').append(
      $("<div>").addClass("text-center p-t").html("<i class='material-icons size-30' style='color: #F44336;'>error_outline</i>")
    ).append(
      $("<div>").addClass("text-center p-b").text("No hay información disponible")
    )
  }
  if ($(window).width() < 992) {
    $("#navbar").append($("#side-menu"));
  }
});
